import { QueryClient } from '@tanstack/react-query';

/** Пауза, в течение которой уже полученные данные считаются свежими. */
const STALE_TIME_MS = 30_000;

/**
 * Общий QueryClient приложения.
 *
 * Повторные запросы отключены: справочник читается быстро, а ретраи на ошибке
 * только оттягивают показ проблемы пользователю. Рефетч при возврате фокуса тоже
 * выключен - в справочнике данные меняются редко, а мигание списка раздражает.
 */
export const createQueryClient = (): QueryClient =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: STALE_TIME_MS,
        retry: false,
        refetchOnWindowFocus: false,
      },
    },
  });
